import React from 'react'
import { browserHistory, Router } from 'react-router'
import { Provider } from 'react-redux'
import PropTypes from 'prop-types'

import $ from 'jquery'
import { TweenMax, Power2 } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

let lastPage = location.pathname + location.search

class App extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired
  }

  shouldComponentUpdate () {
    return false
  }

  onRouterUpdate () {
    const currentPage = location.pathname + location.search

    if (currentPage !== lastPage) {
      if (window.ga !== undefined) {
        window.ga('set', 'page', location.pathname + location.search)
        window.ga('send', 'pageview')
      }
      lastPage = currentPage
    }

    TweenMax.to($(window).add('.content-drawer__content > div'), 0.6, {
      scrollTo: 0,
      ease: Power2.easeInOut,
    })
  }

  render () {
    return (
      <Provider store={this.props.store}>
        <Router history={browserHistory} children={this.props.routes} onUpdate={this.onRouterUpdate} />
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js